import React from "react";
import RailTag from "../../components/terminal/RailTag.jsx";
import { fmtCcy } from "../../components/terminal/format.js";
import ItemActions, { CTX } from "../../components/terminal/ItemActions.jsx";

/* Streaming activity ticker — full-width 220px panel below the
   three-column overview. Rendered from a list prop so the parent
   can swap from polled HTTP to WebSocket (A.7) without re-touching
   this component. */

const STATUS_COLOR = {
  in_flight: "var(--term-green)",
  settling:  "var(--term-green)",
  settled:   "var(--term-ink-2)",
  queued:    "var(--term-ink-2)",
  failed:    "var(--term-red)",
};

export default function ActivityTicker({ events = [], status = "fallback" }) {
  const statusMap = {
    streaming:    { label:"streaming",    color:"var(--term-green)",  showDot:true  },
    loading:      { label:"connecting",   color:"var(--term-amber)",  showDot:false },
    reconnecting: { label:"reconnecting", color:"var(--term-amber)",  showDot:false },
    fallback:     { label:"cached",       color:"var(--term-ink-3)",  showDot:false },
  };
  const s = statusMap[status] || statusMap.fallback;
  return (
    <div style={{ borderTop:"2px solid var(--term-line)", display:"flex", flexDirection:"column", minHeight:0, background:"var(--term-bg-pane)" }}>
      <div className="term-pane-head" style={{ background:"var(--term-bg-pane-2)", padding:"10px 14px", fontFamily:"Inter", fontSize:13, fontWeight:500, color:"var(--term-ink-1)", letterSpacing:"-0.01em", textTransform:"none" }}>
        Activity ticker
        <span className="meta">
          {s.showDot && <span className="dot" />}
          <span style={{ color:s.color }}>{s.label}</span> · <b>{events.length}</b> events
        </span>
      </div>
      <div style={{ flex:1, overflow:"auto" }}>
        <div style={{ display:"grid", gridTemplateColumns:"72px 60px 1fr 110px 110px 96px", gap:14, alignItems:"center", padding:"0 14px", height:24, fontSize:9.5, letterSpacing:"0.12em", color:"var(--term-ink-3)", textTransform:"uppercase", fontWeight:600, borderBottom:"1px solid var(--term-line-dim)", background:"var(--term-bg)", position:"sticky", top:0, zIndex:1 }}>
          <span>TIME</span><span>RAIL</span><span>COUNTERPARTY</span><span>REF</span><span style={{ textAlign:"right" }}>AMOUNT</span><span style={{ textAlign:"right" }}>STATUS</span>
        </div>
        {events.map((a, i) => {
          const v = parseFloat(a.amount) || 0;
          const isIn = v >= 0;
          return (
            <div
              key={a.id || i}
              className="term-has-ctx"
              style={{ display:"grid", gridTemplateColumns:"72px 60px 1fr 110px 110px 96px", gap:14, alignItems:"center", padding:"0 14px", height:26, fontFamily:"JetBrains Mono", fontSize:11, borderBottom:"1px solid var(--term-line-dim)", position:"relative" }}
            >
              <span style={{ color:"var(--term-ink-3)", fontSize:10.5 }}>{a.ts}</span>
              <span><RailTag rail={a.rail} /></span>
              <span style={{ color:"var(--term-ink-1)", fontFamily:"Inter", fontSize:11.5, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{a.counterparty}</span>
              <span style={{ color:"var(--term-ink-3)", fontSize:10.5 }}>{a.reference}</span>
              <span style={{ textAlign:"right", color: isIn ? "var(--term-green)" : "var(--term-red)" }}>
                {isIn ? "+ " : "− "}{fmtCcy(Math.abs(v), a.currency)}
              </span>
              <span style={{ textAlign:"right", fontSize:9.5, letterSpacing:"0.10em", textTransform:"uppercase", color: STATUS_COLOR[a.status] || "var(--term-ink-2)", position:"relative" }}>
                {(a.status || "").replace("_", " ")}
                <span style={{ position:"absolute", right:0, top:"50%", transform:"translateY(-50%)", background:"var(--term-bg-pane-2)", paddingLeft:6 }}>
                  <ItemActions actions={CTX.activity(a)} />
                </span>
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
